<template>
  <div class="page">
    <div class="manuscriptId">修改密码</div>
    <div style="width: 350px;display: flex;flex-direction: column;">
      <div style="margin-top: 50px;" v-if="showhide">
        <el-tabs style="width: 350px;margin-top: 30px;" @tab-click="handleClick" v-model="activeName">
          <el-tab-pane label="手机号验证" name="1">
            <el-input :disabled="true" style="width: 350px;margin-top: 20px;" v-model="username" placeholder="请输入昵称">
            </el-input>
            <div style="position: relative;">
              <el-input style="width: 350px;margin-top: 20px;" v-model="newphone" :placeholder="inputtext"></el-input>
              <div @click="getcode" :class="disabledbtn== false?'chose':'other'">{{btntext}}</div>
            </div>
            <el-input style="width: 350px;margin-top: 20px;" v-model="code" placeholder="请输入验证码"></el-input>
            <el-button @click="nextClickP" style="margin-top: 50px;width: 350px;" type="primary">下一步</el-button>
          </el-tab-pane>
          <el-tab-pane label="邮箱验证" name="2">
            <el-input :disabled="true" style="width: 350px;margin-top: 20px;" v-model="username" placeholder="请输入昵称">
            </el-input>
            <div style="position: relative;">
              <el-input style="width: 350px;margin-top: 20px;" v-model="newemail" :placeholder="inputtext"></el-input>
              <div @click="getcode" :class="disabledbtn1== false?'chose':'other'">{{btntext1}}</div>
            </div>
            <el-input style="width: 350px;margin-top: 20px;" v-model="emailcode" placeholder="请输入验证码"></el-input>
            <el-button @click="nextClickE" style="margin-top: 50px;width: 350px;" type="primary">下一步</el-button>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div style="margin-top: 50px;" v-else>
        <el-input show-password style="width: 350px;margin-top: 20px;" v-model="oldpassword" placeholder="请输入新密码">
        </el-input>
        <el-input show-password style="width: 350px;margin-top: 20px;" v-model="newpassword" placeholder="请再次输入密码">
        </el-input>
        <el-button @click="resetpassword" :loading="resetpasswordloading" style="margin-top: 50px;width: 350px;" type="primary">重置密码</el-button>
        <div class="small">密码长度不低于8位！</div>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from "axios";
  var countdownP = 60;
  var countdownE = 60;
  export default {
    data() {
      return {
        resetpasswordloading:false,
        showhide: true,//是否显示
        activeName: '1',//1是手机号修改密码，2是邮箱修改密码
        username: JSON.parse(this.baseUrl.getCookie("userInfo")).name,//用户名
        oldphone: '',//旧手机号

        oldpassword: '',//请输入密码
        newpassword: '',//请输入新密码
        inputtext: '请输入手机号',
        codetext: '获取手机验证码',

        //手机验证
        btntext: '获取短信验证码',
        disabledbtn: false,
        newphone: '',//新手机号
        code: '',//用户编码
        sccode: '',//生成code
        //邮箱验证
        btntext1: '获取邮箱验证码',
        disabledbtn1: false,
        newemail: '',//邮箱地址
        emailcode: '',//
        scemailcode: '',
      }
    },
    methods: {
      //手机验证码
      settimePhone() {
        if (countdownP == 0) {
          this.btntext = "获取短信验证码";
          this.disabledbtn = false;
          countdownP = 60;
          return;
        } else {
          this.btntext = countdownP + '秒后可重发';
          this.disabledbtn = true;
          countdownP--;
        }
        setTimeout(() => {
          this.settimePhone();
        }, 1000)
      },
      //邮箱验证码
      settimeEmail() {
        if (countdownE == 0) {
          this.btntext1 = "获取邮箱验证码";
          this.disabledbtn1 = false;
          countdownE = 60;
          return;
        } else {
          this.btntext1 = countdownE + '秒后可重发';
          this.disabledbtn1 = true;
          countdownE--;
        }
        setTimeout(() => {
          this.settimeEmail();
        }, 1000)
      },
      //重置密码
      resetpassword() {
        if (!this.oldpassword) {
          this.$Message.error('密码不能为空！');
          return;
        }
        if (this.oldpassword.length < 8) {
          this.$Message.error('新密码至少8位！');
          return;
        }
        if (!this.newpassword) {
          this.$Message.error('确认密码不能为空！');
          return;
        }
        if (this.oldpassword != this.newpassword) {
          this.$Message.error('2次输入密码不一致！');
          return;
        }
        //重置密码操作
        this.resetpasswordloading = true;
        let params = new FormData(); // 创建form对象
        params.append("id", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
        params.append("passwd", this.baseUrl.encode(this.newpassword)); //邮箱地址
        axios.post(this.baseUrl.hbjx + "/user/updTByPrimaryKey", params).then((res) => {
          if (res.data.code == "200") {
            this.baseUrl.setCookie("userInfo", "", -1);
            localStorage.removeItem("pageinfo");
            this.resetpasswordloading = false;
            this.$Message.success('重置密码成功！');
            this.$router.push('/');
          }else{
            this.resetpasswordloading = false;
            this.$Message.error('重置密码失败！');
          }
        });
      },
      //获取验证码
      getcode() {
        if (this.activeName == '1') {
          if (!this.newphone) {
            this.$Message.error('手机号不能为空！');
            return;
          }
          if (this.newphone.length != 11) {
            this.$Message.error('手机号格式不正确！');
            return;
          }
          //还要判断手机号是否存在当前系统中
          //调用接口看当前手机号是否存在系统中，如果存在则下一步操作，不存在给出提示！
          axios.get(this.baseUrl.hbjx + '/user/loadListByPramas', {  //params参数必写 , 如果没有参数传{}也可以
            params: {
              phone: this.newphone,//(passive 被投列表  active  所投列表)
              userId: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
            }
          })
            .then((res) => {
              if (res.data.length != 0) {
                //发送验证码
                this.sendVerificationCode("phone");
              } else {
                this.$Message.error('当前手机号不存在系统中！');
                return;
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        } else {
          if (!this.newemail) {
            this.$Message.error('邮箱地址不能为空！');
            return;
          }
          //var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
          if (this.newemail.indexOf('@') == -1) {
            this.$Message.error('邮箱格式不正确!');
            return;
          }
          //还要判断邮箱是否存在系统中
          axios.get(this.baseUrl.hbjx + '/user/loadListByPramas', {  //params参数必写 , 如果没有参数传{}也可以
            params: {
              email: this.newemail,//(passive 被投列表  active  所投列表)
              userId: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
            }
          })
            .then((res) => {
              if (res.data.length != 0) {
                //发送验证码
                this.sendVerificationCode("email");
              } else {
                this.$Message.error('未绑定此邮箱！');
                return;
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        }
      },
      //发送验证码phone手机验证码，email邮箱验证码
      sendVerificationCode(type) {
        if (type == 'phone') {
          //发送验证码
          this.sccode = this.baseUrl.generateCode();
          let params = new FormData(); // 创建form对象
          params.append("phone", this.newphone); // 手机号
          params.append("verifyCode", this.baseUrl.encode(this.sccode)); //验证码
          axios.post(this.baseUrl.hbjx + "/code/toPhone", params).then((res) => {
            if (res.data == 'OK') {
              this.$Message.success('验证码已发送，请注意查收!');
              this.settimePhone();
            }
          });
        } else if (type == 'email') {
          //获取验证码操作。。。。
          this.scemailcode = this.baseUrl.generateCode();
          let params = new FormData(); // 创建form对象
          params.append("to", this.newemail); // 邮箱地址
          params.append("verifyCode", this.baseUrl.encode(this.scemailcode)); //验证码
          axios.post(this.baseUrl.hbjx + "/code/toMail", params).then((res) => {
            if (res.data == 'OK') {
              this.$Message.success('验证码已发送，请注意查收!');
              this.settimeEmail();
            }
          });
        } else {
          this.$Message.error('操作错误！');
        }
      },
      //短信按钮下一步校验
      nextClickP() {
        if (!this.newphone) {
          this.$Message.error('手机号不能为空！');
          return;
        }
        if (!this.code) {
          this.$Message.error('验证码不能为空！');
          return;
        }
        if (this.code != this.sccode) {
          this.$Message.error('验证码不正确！');
          return;
        }
        //验证通过
        this.showhide = false;
      },
      //邮箱按钮下一步校验
      nextClickE() {
        if (!this.newemail) {
          this.$Message.error('邮箱地址不能为空！');
          return;
        }
        if (!this.emailcode) {
          this.$Message.error('验证码不能为空！');
          return;
        }
        if (this.emailcode != this.scemailcode) {
          this.$Message.error('验证码不正确！');
          return;
        }
        //验证通过
        this.showhide = false;
      },
      handleClick(tab, event) {
        if (this.activeName == '1') {
          this.inputtext = '请输入手机号';
        }
        if (this.activeName == '2') {
          this.inputtext = '请输入邮箱地址';
        }
      }
    },
  }
</script>
<style scoped>
  .other {
    position: absolute;
    top: 28px;
    right: 15px;
    font-weight: bold;
    color: rgb(198, 198, 198);
    pointer-events: none;
  }

  .chose {
    position: absolute;
    top: 23px;
    right: 15px;
    color: #6395f0;
    font-weight: bold;
    cursor: pointer;

  }

  /deep/ .el-tabs__nav {
    width: 100%;
  }

  /deep/ .el-tabs__item {
    width: 50%;
    text-align: center;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: black;
  }

  /deep/ .el-input__inner {
    border: none;
    border-bottom: 1px solid #e6e6e6;
  }

  #tagemail /deep/ .el-input__inner {
    border: none;
  }

  .small {
    width: 350px;
    text-align: center;
    font-size: 13px;
    margin-top: 15px;
    color: #8590a6;
  }

  .manuscriptId {
    font-weight: bold;
    font-size: 24px;
    margin-top: 50px;
    color: #121212;
    cursor: pointer;
  }

  .page {
    display: flex;
    flex-direction: column;

    align-items: center;
    width: 100%;
    height: 700px;
    margin: 5px 0px 5px 0px;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue